import { SET_OIDC_OBJ } from "../actions/setOIDC";


const DEFAULT_STATE = {
    user:{
        profile: null,
        access_token:null
    }
};

export default function (state = DEFAULT_STATE, action) {
    switch (action.type) {
        case SET_OIDC_OBJ:
            return {
                ...state,
                ...state.user,
                user:{
                    profile: action.payload.profile,
                    access_token: action.payload.access_token
                }
            }
        default:
            return state;
    }
}
